import { render, staticRenderFns } from "./SearchChannelTypesDropdown.vue?vue&type=template&id=296d65ca&scoped=true&"
import script from "./SearchChannelTypesDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchChannelTypesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SearchChannelTypesDropdown.vue?vue&type=style&index=0&id=296d65ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d65ca",
  null
  
)

export default component.exports